import { RCCServicesApi } from "react-common-components";
import { IMessage } from "react-common-components/dist/components/Toast/interface";
import { IBusinessGroup, ICompany, IPermissions, IUserConfig } from "src/context/Auth/interface";
import { standardErrorMessages } from "src/utils/errors";

const changeCompanyLogged = async (
	id: number, 
	updateCompanyLogged: (eftba002: ICompany, eftba001: IBusinessGroup, token: string, eftbb001: IPermissions[], userConfig: IUserConfig, administrator: boolean, scheduleRestriction: boolean, tokenExpirationHours: number) => void,
	reload: () => void,
	translate: (text: string, objKeys?: object | undefined) => string,
	addToast: (message: Omit<IMessage, "id">) => void,
	setLoading: (val: boolean) => void
) => {
	try{
		setLoading(true);
		const {data} = await RCCServicesApi.postRequest({
			method: "Business/ChangeCompanyLogged",
			urlParameters: {
				companyId: id
			}
		});
		setLoading(false);
		updateCompanyLogged(data.eftba002, data.eftba001, data.token, data.eftbb001, data.userConfig, data.administrator, data.scheduleRestriction, data.tokenExpirationHours);
		reload();
		addToast({
			color: "green",
			title: translate("Sucesso"),
			description: translate("Empresa logada alterada com sucesso")
		});
	}catch(err){
		setLoading(false);
		standardErrorMessages(err,  "Erro ao trocar de empresa" , addToast);
	}
};

export default changeCompanyLogged;
